<template>
  <div>
    <v-container fluid >
      <dynamic-insights/>
    </v-container>

  </div>
</template>

<script>
  import dynamicInsights from '../components/insights/dynamic-insights/graphe-loader'
  export default {
    name: "customAnalytics",
    components: {
      dynamicInsights
    }
  }
</script>

<style scoped>

</style>
